import { partition } from "lodash";

const commonConfig = (config) =>
  config.map((item) => ({
    size: {
      sm: 6,
      xs: 6,
      lg: 6,
    },
    ...item,
    value: !item.value.old && !item.value.new ? undefined : item.value,
    hasChangeTracking: true,
  }));

const covertFirstLetterToUpperCase = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const applyScreenModifications = (screens, screenChanges) => {
  if (!screenChanges || screenChanges.length === 0 || !screens || screens.length === 0)
    return { screensWithChanges: screens, addedScreenCount: 0, removedScreenCount: 0 };
  const [addedScreens, removedScreens] = partition(screenChanges, (s) => s.name !== "");
  let addedScreenCount = 0;
  let removedScreenCount = 0;
  const updatedScreens = screens.map((s) => {
    const change = removedScreens.some((cs) => cs.id === s.id);
    if (change) {
      removedScreenCount++;
      return {
        ...s,
        changeType: "removed",
      };
    }
    return s;
  });
  return {
    screensWithChanges: [
      ...updatedScreens,
      ...addedScreens.map((s) => {
        addedScreenCount++;
        return {
          ...s,
          changeType: "added",
        };
      }),
    ],
    addedScreenCount,
    removedScreenCount,
  };
};

const fillMissingValidityWithOldValues = (oldValidity, validity) => {
  if (!validity || !oldValidity) return validity;
  return {
    fromDate: validity?.fromDate || oldValidity?.fromDate,
    toDate: validity?.toDate || oldValidity?.toDate,
    startTime: validity?.startTime || oldValidity?.startTime,
    endTime: validity?.endTime || oldValidity?.endTime,
  };
};

const getTargetGroupDetails = (log) => {
  const { targetGroups } = log.changedFields;
  const targetGroupNew = targetGroups[0] || {};
  const { updatedAt, updatedBy } = targetGroupNew;
  const targetGroup =
    log.dataSnapshot?.targetGroups?.find((tg) => tg.id === targetGroupNew.id) || {};
  const targetGroupName = targetGroup.name;
  return {
    name: targetGroupName,
    id: targetGroupNew.id,
    updatedBy,
    updatedAt,
  };
};

const getMediaDetails = (log) => {
  const { medias } = log.changedFields || {};
  const mediaNew = medias?.[0] || {};
  const { updatedAt, updatedBy } = mediaNew;
  const media = log.dataSnapshot?.medias?.find((m) => m.id === mediaNew.id) || {};
  const mediaName = media.name;
  return {
    name: mediaName,
    id: mediaNew.id,
    updatedBy,
    updatedAt,
  };
};

export {
  commonConfig,
  covertFirstLetterToUpperCase,
  applyScreenModifications,
  fillMissingValidityWithOldValues,
  getTargetGroupDetails,
  getMediaDetails,
};
